var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5285_361566)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 173,
    width: 343,
    height: 127,
    rx: 26,
    fill: "#424E54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 165,
    width: 343,
    height: 127,
    rx: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271,
    y: 199,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361,
    y: 206,
    width: 41,
    height: 44,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408,
    y: 206,
    width: 41,
    height: 44,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 206,
    width: 41,
    height: 44,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 206,
    width: 41,
    height: 44,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: -39,
    width: 299,
    height: 127,
    rx: 26,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: -5,
    width: 58,
    height: 58,
    rx: 29,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479,
    y: 2,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 2,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 2,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 364,
    width: 345,
    height: 127,
    rx: 26,
    fill: "#B3D7EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 403,
    width: 33.9411,
    height: 33.9411,
    transform: "rotate(45 92 403)",
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447,
    y: 364,
    width: 345,
    height: 127,
    rx: 26,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 403,
    width: 33.9411,
    height: 33.9411,
    transform: "rotate(45 512 403)",
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 714,
    y: 405,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640,
    y: 136,
    width: 128,
    height: 128,
    rx: 24,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 676,
    y: 172,
    width: 56,
    height: 56,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 136,
    width: 128,
    height: 128,
    rx: 24,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 172,
    width: 56,
    height: 56,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.012,
    y: 31,
    width: 58,
    height: 58,
    transform: "rotate(135 252.012 31)",
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 53,
    width: 41,
    height: 44,
    transform: "rotate(-180 150 53)",
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 53,
    width: 41,
    height: 44,
    transform: "rotate(-180 103 53)",
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 53,
    width: 41,
    height: 44,
    transform: "rotate(-180 56 53)",
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.5,
    y: 91.5,
    width: 294,
    height: 122,
    rx: 21.5,
    transform: "rotate(-180 273.5 91.5)",
    stroke: "#80BDE0",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23,
    y: 206,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 206,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 206,
    width: 41,
    height: 44,
    fill: "#80BDE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5285_361566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.54308aec7e3a74f39d77431a72184065.svg";
export { ForwardRef as ReactComponent };